import DetectionDetails from './DetectionDetails';

export default DetectionDetails;
